import axios from 'axios';
import config from '../../config';

const url = `${config.baseUrl}/api/manifestaciones-interes`;

export const getProyectos = async () => (await axios.get(`${url}/proyectos`)).data;

export const buscarParticipantes = async (oidProyecto, q, page = 1, pageSize = 10) =>
  (await axios.get(`${url}/proyectos/${oidProyecto}/participantes`, { params: { q, page, pageSize } })).data;

export const getManifestaciones = async (params) => (await axios.get(url, { params })).data;

export const getResumen = async (params) => (await axios.get(`${url}/resumen`, { params })).data;

export const getDetalle = async (oid) => (await axios.get(`${url}/${oid}`)).data;

export const crearManifestacion = async (datos) => (await axios.post(url, datos)).data;

export const editarManifestacion = async (oid, datos) => (await axios.put(`${url}/${oid}`, datos)).data;

export const generarNuevaVersion = async (oid) => (await axios.post(`${url}/${oid}/generar`)).data;

export const cargarActaFirmada = async (oid, archivo) => {
  const formData = new FormData();
  formData.append('archivo', archivo);
  return (await axios.post(`${url}/${oid}/firmada`, formData)).data;
};

export const getHistorial = async (oid) => (await axios.get(`${url}/${oid}/historial`)).data;

export const eliminarManifestacion = async (oid, motivo) => axios.delete(`${url}/${oid}`, { data: { motivo } });

export const restaurarManifestacion = async (oid) => (await axios.post(`${url}/${oid}/restaurar`)).data;

export const getArchivo = async (oid, oidDocumento, modo) =>
  (await axios.get(`${url}/${oid}/documentos/${oidDocumento}/archivo`, { params: { modo }, responseType: 'blob' })).data;

/** Mensaje del backend, o el indicado si la respuesta no trae uno. */
export const mensajeDeError = async (error, porDefecto) => {
  const datos = error?.response?.data;
  // Las peticiones de archivos también reciben los errores como blob.
  if (datos instanceof Blob) {
    try {
      return JSON.parse(await datos.text()).message || porDefecto;
    } catch {
      return porDefecto;
    }
  }
  return datos?.message || porDefecto;
};
